(() => {
  if (window.frameSceneFilmReady) return;
  window.frameSceneFilmReady = true;

  const init = () => {
    const films = document.querySelectorAll('.brand-film');
    const firstFilm = [...films].find(section => section.querySelector('video'));
    document.querySelectorAll('[data-film-link]').forEach(link => {
      link.hidden = !firstFilm;
      if (firstFilm) link.href = `#${firstFilm.id}`;
    });
    films.forEach(section => {
      const video = section.querySelector('video');
      const button = section.querySelector('.brand-film-play');
      const error = section.querySelector('.brand-film-error');
      if (!video || !button || section.dataset.filmReady) return;
      section.dataset.filmReady = 'true';
      button.hidden = !video.paused;
      video.addEventListener('play', () => { button.hidden = true; error.hidden = true; });
      video.addEventListener('pause', () => { button.hidden = false; });
      button.addEventListener('click', async () => {
        try {
          await video.play();
        } catch (cause) {
          error.hidden = false;
          console.warn('Brand film playback failed', cause);
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
})();
